import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-oauth',
    template: `<router-outlet></router-outlet>`, // Sin HTML
    styles: [] ,    // Sin CSS
    standalone: true,
    imports: [RouterOutlet],
})
export class OauthComponent {
    /**
     * Constructor
     */
    constructor() {}
}
